/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const SettingsTabSkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={`col-12 col-md-8 ${classes.rightContainer}`}>
      <div className={classes.rightTopContainer}>
        <div className={classes.rightTopContainerWrapper}>
          <div className={classes.iconWrapper}><Skeleton count={1} width={24} height={24} className={classes.shortSk} /></div>
          <div className={classes.containerDescription}>
            <h1>  <Skeleton count={1} width={100} className={classes.shortSk} /></h1>
            <p>  <Skeleton count={1} width={300} className={classes.shortSk} /></p>
          </div>
        </div>
        <div className={classes.button}>
          <Skeleton count={1} width={53} className={classes.shortSk} />
        </div>
      </div>
    </div>      
  );
};

export default SettingsTabSkeleton;
